module.exports = __webpack_public_path__ + "img/faq3.394717d3.png";